import "../omega-theme.augmentation";
import { defineTheme, type ThemeDefinition } from "@omega/theme";

import { MOBILE_THEME } from "./mobile.theme";

/**
 * Лесная тема — светлый фон, зелёные и земляные акценты (по мотивам nbp Forest).
 */
export const FOREST_THEME: ThemeDefinition = defineTheme(
    {
        id: "forest",
        name: "Лес",
        scheme: "light",
        tokens: {
            color: {
                text: {
                    primary: "#1B3D16",
                    secondary: "#2D5A27",
                    disabled: "#6B8C6A",
                    emphasis: "#142E10",
                    inverse: "#FFFFFF",
                    danger: "#C41E3A",
                },
                background: { default: "#F0F5EE" },
                surface: {
                    base: "#FFFFFF",
                    hover: "#E3F0E0",
                    header: "#B8D4B4",
                    modal: "#F5FAF3",
                    disabled: "#D4E6D4",
                    selected: "#E8F2E6",
                },
                border: {
                    default: "#4A7C43",
                    focus: "#2D5A27",
                    muted: "#B8D4B4",
                    danger: "#C41E3A",
                    disabled: "#C8D9C6",
                },
                accent: {
                    main: "#2D5A27",
                    contrastText: "#FFFFFF",
                },
                danger: { main: "#C41E3A" },
                success: { main: "#388E3C" },
                warning: {
                    main: "#B8860B",
                    contrastText: "#1B3D16",
                },
                neutral: {
                    main: "#1B3D16",
                    contrastText: "#FFFFFF",
                },
                status: {
                    success: "#388E3C",
                    successSurface: "#D4E6D4",
                    warningSurface: "#F5E9C8",
                    error: "#C41E3A",
                    errorSurface: "#F9D8DE",
                    info: "#2E7D32",
                    infoSurface: "#E3F0E0",
                },
                alert: {
                    success: "#2E7D32",
                },
                skeleton: {
                    base: "#B8D4B4",
                    highlight: "#D4E6D4",
                },
            },
        },
    },
    { base: MOBILE_THEME },
);
